var _defs, _path, _path2, _circle, _circle2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrecision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#03BCAA",
    strokeDasharray: "3 3",
    d: "M1 1h75v75H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.75V1h18.75M1 57.25V76h18.75m37.5-75H76v18.75m0 37.5V76H57.25",
    stroke: "#050505"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 25.5,
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 12.5,
    stroke: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 34v8M42 38h-8",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })));
}

var MemoSvgPrecision = /*#__PURE__*/React.memo(SvgPrecision);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzciIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA3NyA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9Ijc1IiBoZWlnaHQ9Ijc1IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjMgMyIvPgo8cGF0aCBkPSJNMSAxOS43NVYxSDE5Ljc1TTEgNTcuMjVWNzZIMTkuNzVNNTcuMjUgMUg3NlYxOS43NU03NiA1Ny4yNVY3Nkg1Ny4yNSIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxjaXJjbGUgY3g9IjM4LjUiIGN5PSIzOC41IiByPSIyNS41IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8Y2lyY2xlIGN4PSIzOC41IiBjeT0iMzguNSIgcj0iMTIuNSIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxwYXRoIGQ9Ik0zOCAzNFY0MiIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtZGFzaGFycmF5PSIyLjc0IDIuNzQiLz4KPHBhdGggZD0iTTQyIDM4TDM0IDM4IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8L3N2Zz4K";
export { MemoSvgPrecision as ReactComponent };